export enum ObjectPropertyFormat {
  TEXT = 'TEXT',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  FILE_SIZE = 'FILE_SIZE'
}
